import React, { useState } from "react";
import { useFilters } from "./FilterContext";
import MainCategory from "./MainCategory";
import MobileFilter from "./MobileFilter";

function LeftBar() {
  const {
    selectedFilters,
    removeFilter,
    clearAllFilters,
    applyPendingFilters,
    clearPendingFilters,
    seedPendingFromFilters,
    beginPendingSession,
    endPendingSession,
    filterData,
    isSkeletonLoading,
    sortOption,
    handleSortChange,
    isMobile,
    loader,
  } = useFilters();
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

  const lockBodyScroll = () => {
    if (typeof document !== "undefined") {
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
    }
  };

  const unlockBodyScroll = () => {
    if (typeof document !== "undefined") {
      document.body.style.overflow = "";
      document.body.style.touchAction = "";
    }
  };

  const openMobileFilter = () => {
    seedPendingFromFilters();
    beginPendingSession();
    setIsMobileFilterOpen(true);
    lockBodyScroll();
  };
  const closeMobileFilter = () => {
    // Clear pending filters when closing without applying
    clearPendingFilters();
    endPendingSession();
    setIsMobileFilterOpen(false);
    unlockBodyScroll();
  };

  const parentCategoryId =
    document.getElementById("parent_level_cat")?.value || null;

  return (
    <>
      {isSkeletonLoading ? // 👇 optional: show loader or skeleton while loading
      null : (
        <>
          <div className="leftNav" id="left_panel">
            <h2 className="filter-title">Filters</h2>

            {selectedFilters.length > 0 && (
              <div className="selected-filters">
                <h4>Selected Filters:</h4>
                <div className="filter-tags">
                  {selectedFilters.map(({ category, label, value }) => (
                    <span key={`${category}-${label}`} className="filter-tag">
                      <button
                        onClick={(e) => {
                          if (loader) {
                            e.preventDefault();
                          } else {
                            removeFilter(category, label);
                          }
                        }}
                        className="remove-btn"
                        disabled={loader}
                      >
                        {value}
                      </button>
                    </span>
                  ))}
                </div>
                <button
                  onClick={(e) => {
                    if (loader) {
                      e.preventDefault();
                    } else {
                      clearAllFilters();
                    }
                  }}
                  className="clear-all-btn"
                  disabled={loader}
                >
                  Clear All Filters
                </button>
              </div>
            )}

            {/* Render categories from API filterData */}
            {filterData.map((main, idx) => (
              <MainCategory
                key={`${main.title}-${idx}`}
                isLast={idx === filterData.length - 1}
                main={{
                  title: main.title,
                  link: main.link,
                  subcategories: main.sections.map((section) => ({
                    key: `${main.title}-${section.label}`
                      .toLowerCase()
                      .replace(/\s+/g, "_"),
                    label: section.label,
                    options: section.options,
                  })),
                  openStatus: main.open
                }}
                isParent={parentCategoryId == null ? true : false}
              />
            ))}
          </div>

          {/* Mobile Filter */}
          <div className="category-filter-sort-bar mobile-filters">
            <div className="category-filter-toggle" onClick={openMobileFilter}>
              <img
                src="https://www.ourgreenhouse.com/content/sortby_arrow.svg"
                alt=""
              />
              <p>FILTER</p>
            </div>

            {/* Sort UI */}
            <div className="category-sort-toggle">
              <img
                src="https://www.ourgreenhouse.com/content/arrowsdownup-.png"
                alt=""
              />
              <div className="sort-options">
                <label>Sort by:</label>
                <select value={sortOption} onChange={handleSortChange}>
                  <option value="0">Default</option>
                  <option value="3">Newest Items</option>
                  <option value="4">Best Selling</option>
                  <option value="1">Price: Ascending</option>
                  <option value="2">Price: Descending</option>
                </select>
              </div>
            </div>
          </div>
          {/* Fullscreen Mobile Filter Drawer */}
          {isMobileFilterOpen && (
            <div className="mobile-filter-overlay">
              <div className="mobile-filter-fullscreen">
                <button className="close-btn" onClick={closeMobileFilter}>
                  ✕
                </button>
                <MobileFilter
                  sidebarData={filterData.map((main) => ({
                    title: main.title,
                    link: main.link,
                    subcategories: main.sections.map((section) => ({
                      key: `${main.title}-${section.label}`
                        .toLowerCase()
                        .replace(/\s+/g, "_"),
                      label: section.label,
                      options: section.options,
                    })),
                  }))}
                  onApply={() => {
                    applyPendingFilters();
                    endPendingSession();
                    setIsMobileFilterOpen(false);
                    unlockBodyScroll();
                  }}
                  onCancel={closeMobileFilter}
                />
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default LeftBar;
